import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import Particles from 'particlesjs';

import '../styles/tribe.scss';
import TribeMember from './team/TribeMebmer';
import team from '../constants/team';

function Tribe() {
  const [teamState] = useState(team.team);
  useEffect(() => {
    AOS.refreshHard();
    Particles.init({
      selector: '.background',
      color: ['#A9A9A9', '#072a33'],
      sizeVariations: 5,
      connectParticles: true,
    });
  });

  return (
    <div className="Tribe">
      <p className="titleTribe">Our Tribe</p>
      <div className="container-fluid tribe-container">
        {/*SINGLE PHOTO*/}
        <div className="row">
          <TribeMember
            image={teamState[13]}
            hoveredImage={team.hovered[13]}
            name={team.names[13]}
          />
        </div>

        {/*THREE PHOTOS*/}
        <div className="row">
          <TribeMember
            image={teamState[0]}
            hoveredImage={team.hovered[0]}
            name={team.names[0]}
          />
          <TribeMember
            image={teamState[1]}
            hoveredImage={team.hovered[1]}
            name={team.names[1]}
          />
          <TribeMember
            image={teamState[2]}
            hoveredImage={team.hovered[2]}
            name={team.names[2]}
          />
        </div>

        {/*TWO PHOTOS*/}
        <div className="row pull-up">
          <TribeMember
            image={teamState[3]}
            hoveredImage={team.hovered[3]}
            name={team.names[3]}
          />
          <TribeMember
            image={teamState[4]}
            hoveredImage={team.hovered[4]}
            name={team.names[4]}
          />
        </div>

        {/*THREE PHOTOS*/}
        <div className="row">
          <TribeMember
            image={teamState[5]}
            hoveredImage={team.hovered[5]}
            name={team.names[5]}
          />
          <TribeMember
            image={teamState[6]}
            hoveredImage={team.hovered[6]}
            name={team.names[6]}
          />
          <TribeMember
            image={teamState[7]}
            hoveredImage={team.hovered[7]}
            name={team.names[7]}
          />
        </div>

        {/*TWO PHOTOS*/}
        <div className="row">
          <TribeMember
            image={teamState[8]}
            hoveredImage={team.hovered[8]}
            name={team.names[8]}
          />
          <TribeMember
            image={teamState[9]}
            hoveredImage={team.hovered[9]}
            name={team.names[9]}
          />
        </div>

        {/*THREE PHOTOS*/}
        <div className="row">
          <TribeMember
            image={teamState[10]}
            hoveredImage={team.hovered[10]}
            name={team.names[10]}
          />
          <TribeMember
            image={teamState[11]}
            hoveredImage={team.hovered[11]}
            name={team.names[11]}
          />
          <TribeMember
            image={teamState[12]}
            hoveredImage={team.hovered[12]}
            name={team.names[12]}
          />
        </div>

        {/*SINGLE PHOTO*/}
        <div className="row">
          <TribeMember
            image={teamState[14]}
            hoveredImage={team.hovered[14]}
            name={team.names[14]}
          />
        </div>
      </div>
    </div>
  );
}

export default Tribe;
